import * as React from 'react'

export function FillRemainingSpace(): React.JSX.Element {
  return <div aria-hidden='true' className='flex-1 shrink' />
}
